import React, { useContext } from "react";

import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';
// material
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { AppBar, Box, Button, Hidden, IconButton, Toolbar } from '@material-ui/core';
//
import Searchbar from './Searchbar';
import AccountPopover from './AccountPopover';
import { BrandContext } from "../../contexts/BrandContext";
import TravelCoSelector from "../../components/igtm/ReportViews/TaxiBookings/TravelCoSelector";
import FpCoSelector from "../../components/igtm/ReportViews/FpCo/FpCoSelector";
import { callToActionTools } from "./SidebarConfig";
import { CallToActionContext } from "../../contexts/CallToActionContext";



// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up('xl')]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`
  }
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('xl')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5)
  }
}));

// ----------------------------------------------------------------------

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func
};

export default function DashboardNavbar({ onOpenSidebar }) {


  const brand = useContext(BrandContext);
  const {
    brand:{
      mode=''
    }
  } = brand;
  const callToAction = useContext(CallToActionContext);
  
  const tools = callToActionTools(brand,callToAction);

  return (
    <RootStyle>
      <ToolbarStyle>
        <Hidden xlUp>
          <IconButton
            onClick={onOpenSidebar}
            sx={{ mr: 1, color: 'text.primary' }}
          >
            <Icon icon={menu2Fill} />
          </IconButton>
        </Hidden>

        <Searchbar />
        <Box sx={{ flexGrow: 1 }} >
          {mode === 'travelCo' && <TravelCoSelector/>}
          {mode === 'fpCo' && <FpCoSelector/>}
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            '& > *:not(:first-of-type)': {
              ml: { xs: 0.5, sm: 2, lg: 3 }
            }
          }}
        >
          {mode === 'schoolAdmin' &&
            <Hidden lgDown>
              {tools.map((button,index) => {

				const {
					action,
					icon,
					title:text
				} = button;

				return (
					<Button
						key= {index}
						sx={{marginRight: 0}}
						onClick={action}
						startIcon={icon}
					>
						{text}
					</Button>
				);

			  })}
            </Hidden> 
          }
          <AccountPopover/>
        </Box>
      </ToolbarStyle>
    </RootStyle>
  );
}
